import { Link, useLocation } from 'react-router-dom';
import { TextButton } from '@zillow/constellation-10';
import { IconChevronLeftFilled } from '@zillow/constellation-icons';

import { YOUR_RENTAL } from '../../constants/routeConstants';

export function ParticipantBreadcrumb({
  breadcrumbLink,
  breadcrumbText,
}: {
  breadcrumbLink: string;
  breadcrumbText: string;
}) {
  const { search } = useLocation();

  return (
    <TextButton icon={<IconChevronLeftFilled />} asChild>
      {breadcrumbLink === YOUR_RENTAL ? (
        <a href={`https://zillow.com${breadcrumbLink}`}>{breadcrumbText}</a>
      ) : (
        <Link to={`${breadcrumbLink}${search}`}>{breadcrumbText}</Link>
      )}
    </TextButton>
  );
}
